export const SHOW_BUSY_INDICATOR_EVENT = 'SHOW_BUSY_INDICATOR';
export const HIDE_BUSY_INDICATOR_EVENT = 'HIDE_BUSY_INDICATOR';
import { CommunicatorService } from 'ui-ng-component-communicator';

export class BusyIndicatorService {
  message: string;
  constructor(private ngComponentCommunicatorService: CommunicatorService) {}

  show(message: string) {
    this.message = message;
    this.ngComponentCommunicatorService.publish(SHOW_BUSY_INDICATOR_EVENT);
  }

  hide() {
    this.message = '';
    this.ngComponentCommunicatorService.publish(HIDE_BUSY_INDICATOR_EVENT);
  }
}

angular.module('capability-ng-academic-planner').service('ngBusyIndicatorService', BusyIndicatorService);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/busy_indicator/busy_indicator_srv.ts